module.exports = __webpack_public_path__ + "static/img/light_texture2.b416d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/textures/light_texture2.png
// module id = 443
// module chunks = 1